var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('img',{staticClass:"loadingGif",attrs:{"src":require('../../assets/loading.gif')}})])}
var staticRenderFns = []

export { render, staticRenderFns }